/** A4 at 96dpi — mirrors the page size used by the PDF renderer. */
export const PREVIEW_PAGE_HEIGHT_PX = { portrait: 1123, landscape: 794 };

/** Same A4 geometry, shaped for the GrapesJS canvas (CSS string dims). */
export const CANVAS_PAGE_SIZE = {
  portrait: { width: "794px", minHeight: "1123px" },
  landscape: { width: "1123px", minHeight: "794px" },
};

export const SAVE_STATE_LABELS = {
  dirty: "Unsaved changes",
  saving: "Saving…",
  error: "Save failed — will retry",
};

export const AUTOSAVE_DEBOUNCE_MS = 3000;

export const DRAFT_STORAGE_PREFIX = "doc-template-draft";

export const EMPTY_PREVIEW_HTML =
  "<div style='padding:24px;color:#64748b;font-family:sans-serif;'>No template content yet. If this is unexpected, restore an earlier version from the Versions panel.</div>";

// Shown instead of EMPTY_PREVIEW_HTML while creating a brand-new template -
// the Versions panel is disabled until the first save, so pointing at it
// here would send the user to a tab they can't use yet.
export const EMPTY_PREVIEW_HTML_NEW =
  "<div style='padding:24px;color:#64748b;font-family:sans-serif;'>No content yet. Switch to Edit layout and add a block from the panel on the right to get started.</div>";
